'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var _uniqueId = require('lodash/uniqueId');
var faQuestionCircle = require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');
var components_DescriptionLabel = require('./DescriptionLabel.js');
var ConditionalWrap = require('conditional-wrap');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _uniqueId__default = /*#__PURE__*/_interopDefaultLegacy(_uniqueId);
var ConditionalWrap__default = /*#__PURE__*/_interopDefaultLegacy(ConditionalWrap);

var _excluded = ["children", "descriptionProps", "isTextWrapped", "label", "valueProps", "hasTooltip", "tooltipProps"];

var _templateObject, _templateObject2;
var Columns = bumbag.styled(bumbag.Columns)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  & > div:last-child {\n    width: 1px;\n  }\n\n  @media screen and (max-width: 768px) {\n    ", ";\n  }\n"])), function (props) {
  return props.minBreakpoint !== 'mobile' && bumbag.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n        & > div:first-child {\n          padding-bottom: 0px;\n        }\n\n        & > div:last-child {\n          padding-top: 0px;\n          width: 100%;\n        }\n      "])));
});
function LabelWrapper(props) {
  var children = props.children,
      descriptionProps = props.descriptionProps,
      isTextWrapped = props.isTextWrapped,
      label = props.label,
      valueProps = props.valueProps,
      hasTooltip = props.hasTooltip,
      tooltipProps = props.tooltipProps,
      restProps = _objectWithoutPropertiesLoose__default["default"](props, _excluded);

  var _React$useState = React__default["default"].useState(function () {
    return _uniqueId__default["default"]('medipass-label-wrapper-');
  }),
      id = _React$useState[0];

  return /*#__PURE__*/React__default["default"].createElement(Columns, restProps, /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, null, /*#__PURE__*/React__default["default"].createElement(ConditionalWrap__default["default"], {
    condition: hasTooltip // @ts-expect-error TS(7006): Parameter 'children' implicitly has an 'any' type.
    ,
    wrap: function wrap(children) {
      return (
        /*#__PURE__*/
        // @ts-expect-error TS(2741): Property 'content' is missing in type '{ children:... Remove this comment to see the full error message
        React__default["default"].createElement(bumbag.Tooltip, _extends__default["default"]({
          placement: "top",
          hasArrow: true
        }, tooltipProps), /*#__PURE__*/React__default["default"].createElement(bumbag.Flex, null, children, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: faQuestionCircle.faQuestionCircle,
          className: "ml-1 text-xs text-secondary-base"
        }))))
      );
    }
  }, /*#__PURE__*/React__default["default"].createElement(components_DescriptionLabel["default"], _extends__default["default"]({
    id: id
  }, descriptionProps), label))), /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, _extends__default["default"]({
    "aria-labelledby": id,
    fontWeight: "semibold",
    overflowWrap: isTextWrapped ? 'break-word' : 'normal'
  }, valueProps), children));
}
LabelWrapper.defaultProps = {
  descriptionProps: {},
  isTextWrapped: true,
  valueProps: {},
  hasTooltip: false,
  tooltipProps: {},
  children: null
};

exports["default"] = LabelWrapper;
